// Configuration for different environments
interface Config {
  apiUrl: string;
  environment: 'development' | 'production';
}

// Default configuration - uses environment variables if available
const defaultConfig: Config = {
  apiUrl: process.env.REACT_APP_API_URL || '/api',
  environment: (process.env.NODE_ENV as 'development' | 'production') || 'development'
};

// Production configuration 
// IMPORTANT: Update this URL before deploying to production
// Replace 'https://your-production-api-domain.com/api' with your actual production API URL
const productionConfig: Config = {
  apiUrl: 'https://budgie-api-f278a5b62f57.herokuapp.com/api', // TODO: Update this for production
  environment: 'production'
};

// Export the appropriate configuration based on environment
export const config: Config = defaultConfig.environment === 'production' 
  ? productionConfig 
  : defaultConfig;

// Helper function to get API URL
export const getApiUrl = (): string => config.apiUrl;

// Log configuration in development for debugging
if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', {
    environment: config.environment,
    apiUrl: config.apiUrl
  });
} 